/**
 * @function updateCookiePolicyConsent
 * @memberof Promega.Util
 * @description Updates GTM consent mode
 * @param {Number} cookiePolicyValue The current cookiePolicyValue
 */
export default function updateCookiePolicyConsent(cookiePolicyValue) {
    const PROMEGA_COOKIE_POLICY = "promegaCookiePolicy";
    const COOKIE_TYPE_U = 0;
    const COOKIE_TYPE_N = 1;
    const COOKIE_TYPE_P = 2;
    const COOKIE_TYPE_S = 4;
    const COOKIE_TYPE_M = 8;


    let adStorage = (cookiePolicyValue & COOKIE_TYPE_M) ? 'granted' : 'denied';
    let analyticsStorage = (cookiePolicyValue & COOKIE_TYPE_S) ? 'granted' : 'denied';
    let userData = (cookiePolicyValue & COOKIE_TYPE_M) ? 'granted' : 'denied';
    let adPersonalization = (cookiePolicyValue & COOKIE_TYPE_M) ? 'granted' : 'denied';

    if (gtag) {
        gtag('consent', 'update', {
            ad_storage: adStorage,
            analytics_storage: analyticsStorage,
            ad_user_data: userData,
            ad_personalization: adPersonalization
        });
    }
    if (window.clarity) {
        window.clarity('consentv2', {
            ad_Storage: adStorage,
            analytics_Storage: analyticsStorage
        });
    }

    // Build dataLayer value for promegaCookiePolicy
    if (window.dataLayer) {
        let pcp = [];

        if (cookiePolicyValue & COOKIE_TYPE_N) pcp.push('Necessary');
        if (cookiePolicyValue & COOKIE_TYPE_P) pcp.push('Preferences');
        if (cookiePolicyValue & COOKIE_TYPE_S) pcp.push('Statistical');
        if (cookiePolicyValue & COOKIE_TYPE_M) pcp.push('Marketing');

        let pcpValues = pcp.toString();
        window.dataLayer.push(JSON.parse('{"event":"cookieConsentAgree","' + PROMEGA_COOKIE_POLICY + '":"' + pcpValues + '"}'));
    }
}